import { Component } from '@angular/core';

@Component({
  selector: 'app-save-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './save-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class SaveIconComponent {}
